// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/login-meta-left-image.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdmissionNoLogin-module__mainContainer {
    display: flex;
    width: 100%;
    height: 100vh;
    position: relative;
    overflow: hidden;
    background-color: #26878F;
    font-family: "Poppins", sans-serif;
}

.AdmissionNoLogin-module__leftContainer {
    width: 50%;
    background-size: cover;
    background-position: center;
}

.AdmissionNoLogin-module__card {
    position: relative;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
}

.AdmissionNoLogin-module__rightContainer {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #FFFFFF;
    border-bottom-left-radius: 40px;
    border-top-left-radius: 40px;
    padding: 40px;
    position: relative;
}

.AdmissionNoLogin-module__loginLogo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.AdmissionNoLogin-module__loginForm {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 40px;
    max-width: 470px;
    /* background-color: yellowgreen; */
}

.AdmissionNoLogin-module__loginFormTitle {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
}

.AdmissionNoLogin-module__loginFormTitle h2 {
    font-weight: 500;
    font-style: Medium;
    font-size: 36px;
    text-align: center;
    color: #101010;
}

.AdmissionNoLogin-module__loginFormTitle p {
    font-weight: 400;
    font-style: Medium;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #00344D;
}

.AdmissionNoLogin-module__inputContainer {
    width: 100%;
    gap: 16px;
    display: flex;
    flex-direction: column;
}

.AdmissionNoLogin-module__inputWrapper {
    position: relative;
}

.AdmissionNoLogin-module__inputLabel {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    color: #999;
    pointer-events: none;
    transition: all 0.3s ease;
    background: #FFFFFF;
    padding: 0 4px;
}

.AdmissionNoLogin-module__float {
    top: 0;
    font-size: 12px;
    color: #22878E;
    transform: translateY(-50%);
}

.AdmissionNoLogin-module__textInput {
    width: 100%;
    height: 56px;
    border: 2px solid #85878A;
    border-radius: 10px;
    padding: 4px;
    font-weight: 400;
    color: #080E14;
    font-size: 20px;
    outline: none;
}

.AdmissionNoLogin-module__textInput::placeholder {
    color: #85878A;
}

.AdmissionNoLogin-module__textInput:focus {
    border-color: #1A6976;
}

.AdmissionNoLogin-module__textInput:hover {
    border-color: #1A6976;
}

.AdmissionNoLogin-module__buttonsContainer {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

.AdmissionNoLogin-module__primaryButton {
    width: 100%;
    height: 56px;
    border-radius: 100px;
    background-color: #1A6976;
    color: #FFFFFF;
    box-shadow: 0px 1px 4px 0px #00000029;
    border: none;
    cursor: pointer;
}

.AdmissionNoLogin-module__primaryButton:disabled {
    background-color: #E6E7E8;
    color: #6C6E72;
    cursor: not-allowed;
}

.AdmissionNoLogin-module__secondaryButton {
    width: 100%;
    height: 56px;
    border-radius: 100px;
    background-color: #FFFFFF;
    color: #1A6976;
    border: none;
    cursor: pointer;
}

.AdmissionNoLogin-module__supportMessage {
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;
    color: #00344D;
}

.AdmissionNoLogin-module__prefilledInput {
    border-radius: 10px 10px 0 0;
    border-bottom: 2px solid #49454F;
    background-color: #C0DCE1;
    height: 56px;
    width: 100%;
    display: flex;
    align-items: center;
    padding-left: 12px;
    font-size: 20px;
    font-weight: 400;
    color: #080E14;
}

.AdmissionNoLogin-module__changeButton {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
}

.AdmissionNoLogin-module__otpInputs {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    height: 56px;
}

.AdmissionNoLogin-module__otpInputText {
    height: 100%;
    width: 99.5px;
    border: 2px solid #85878A;
    border-radius: 16px;
    padding: 4px;
    font-weight: 400;
    color: #080E14;
    font-size: 20px;
    outline: none;
    text-align: center;
}

.AdmissionNoLogin-module__otpInfo {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 4px;
}

.AdmissionNoLogin-module__otpInfo p {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 24px;
    vertical-align: middle;
}

.AdmissionNoLogin-module__underline {
    text-decoration: underline;
    text-decoration-style: solid;
    text-decoration-offset: 0%;
    text-decoration-thickness: 0%;
}
.AdmissionNoLogin-module__sendOtpButtonContainer {
    width: 100%;
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
}

.AdmissionNoLogin-module__sendOtpButtonContainer button {
    width: 100%;
    border-radius: 100px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background-color: transparent;
    color: #1A6976;
    border: 2px solid #1A6976;
    cursor: pointer;
}

.AdmissionNoLogin-module__sendOtpButtonContainer button:disabled {
    background-color: #E6E7E8;
    color: #85878A;
    cursor: not-allowed;
    border: 1px solid var(--Neutral-70, #9D9FA1)
}
.AdmissionNoLogin-module__backButtonContainer{
    position: absolute;
    top: 40px;
    left: 40px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
}
.AdmissionNoLogin-module__backButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #FFFFFF;
    cursor: pointer;
    box-shadow: 0px 0px 10px 0px #0000001F;
}
.AdmissionNoLogin-module__togglePasswordButton {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    z-index: 5;
}
.AdmissionNoLogin-module__errorMessage{
    color: #ED4337;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 24px;
}
.AdmissionNoLogin-module__inputError{
    border-color: #ED4337;
}
.AdmissionNoLogin-module__errorLabel{
    color: #ED4337;
}
.AdmissionNoLogin-module__passwordInputWrapper{
    position: relative;
}`, "",{"version":3,"sources":["webpack://./src/pages/login/AdmissionNoLogin.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yDAAsE;IACtE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,MAAM;IACN,eAAe;IACf,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;IACzB,cAAc;IACd,qCAAqC;IACrC,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB;AACJ;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,aAAa;IACb,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,sCAAsC;AAC1C;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,UAAU;AACd;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".mainContainer {\n    display: flex;\n    width: 100%;\n    height: 100vh;\n    position: relative;\n    overflow: hidden;\n    background-color: #26878F;\n    font-family: \"Poppins\", sans-serif;\n}\n\n.leftContainer {\n    width: 50%;\n    background-size: cover;\n    background-position: center;\n}\n\n.card {\n    position: relative;\n    height: 100%;\n    background-image: url('../../assets/images/login-meta-left-image.svg');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    width: 100%;\n}\n\n.rightContainer {\n    width: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #FFFFFF;\n    border-bottom-left-radius: 40px;\n    border-top-left-radius: 40px;\n    padding: 40px;\n    position: relative;\n}\n\n.loginLogo {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.loginForm {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 40px;\n    max-width: 470px;\n    /* background-color: yellowgreen; */\n}\n\n.loginFormTitle {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 24px;\n}\n\n.loginFormTitle h2 {\n    font-weight: 500;\n    font-style: Medium;\n    font-size: 36px;\n    text-align: center;\n    color: #101010;\n}\n\n.loginFormTitle p {\n    font-weight: 400;\n    font-style: Medium;\n    font-size: 16px;\n    line-height: 24px;\n    text-align: center;\n    color: #00344D;\n}\n\n.inputContainer {\n    width: 100%;\n    gap: 16px;\n    display: flex;\n    flex-direction: column;\n}\n\n.inputWrapper {\n    position: relative;\n}\n\n.inputLabel {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 16px;\n    color: #999;\n    pointer-events: none;\n    transition: all 0.3s ease;\n    background: #FFFFFF;\n    padding: 0 4px;\n}\n\n.float {\n    top: 0;\n    font-size: 12px;\n    color: #22878E;\n    transform: translateY(-50%);\n}\n\n.textInput {\n    width: 100%;\n    height: 56px;\n    border: 2px solid #85878A;\n    border-radius: 10px;\n    padding: 4px;\n    font-weight: 400;\n    color: #080E14;\n    font-size: 20px;\n    outline: none;\n}\n\n.textInput::placeholder {\n    color: #85878A;\n}\n\n.textInput:focus {\n    border-color: #1A6976;\n}\n\n.textInput:hover {\n    border-color: #1A6976;\n}\n\n.buttonsContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    width: 100%;\n}\n\n.primaryButton {\n    width: 100%;\n    height: 56px;\n    border-radius: 100px;\n    background-color: #1A6976;\n    color: #FFFFFF;\n    box-shadow: 0px 1px 4px 0px #00000029;\n    border: none;\n    cursor: pointer;\n}\n\n.primaryButton:disabled {\n    background-color: #E6E7E8;\n    color: #6C6E72;\n    cursor: not-allowed;\n}\n\n.secondaryButton {\n    width: 100%;\n    height: 56px;\n    border-radius: 100px;\n    background-color: #FFFFFF;\n    color: #1A6976;\n    border: none;\n    cursor: pointer;\n}\n\n.supportMessage {\n    font-weight: 500;\n    font-style: Medium;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0px;\n    color: #00344D;\n}\n\n.prefilledInput {\n    border-radius: 10px 10px 0 0;\n    border-bottom: 2px solid #49454F;\n    background-color: #C0DCE1;\n    height: 56px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    padding-left: 12px;\n    font-size: 20px;\n    font-weight: 400;\n    color: #080E14;\n}\n\n.changeButton {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 4px;\n}\n\n.otpInputs {\n    display: flex;\n    justify-content: space-between;\n    gap: 24px;\n    height: 56px;\n}\n\n.otpInputText {\n    height: 100%;\n    width: 99.5px;\n    border: 2px solid #85878A;\n    border-radius: 16px;\n    padding: 4px;\n    font-weight: 400;\n    color: #080E14;\n    font-size: 20px;\n    outline: none;\n    text-align: center;\n}\n\n.otpInfo {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n    gap: 4px;\n}\n\n.otpInfo p {\n    font-weight: 400;\n    font-style: Regular;\n    font-size: 16px;\n    line-height: 24px;\n    vertical-align: middle;\n}\n\n.underline {\n    text-decoration: underline;\n    text-decoration-style: solid;\n    text-decoration-offset: 0%;\n    text-decoration-thickness: 0%;\n}\n.sendOtpButtonContainer {\n    width: 100%;\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.sendOtpButtonContainer button {\n    width: 100%;\n    border-radius: 100px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    background-color: transparent;\n    color: #1A6976;\n    border: 2px solid #1A6976;\n    cursor: pointer;\n}\n\n.sendOtpButtonContainer button:disabled {\n    background-color: #E6E7E8;\n    color: #85878A;\n    cursor: not-allowed;\n    border: 1px solid var(--Neutral-70, #9D9FA1)\n}\n.backButtonContainer{\n    position: absolute;\n    top: 40px;\n    left: 40px;\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n}\n.backButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background-color: #FFFFFF;\n    cursor: pointer;\n    box-shadow: 0px 0px 10px 0px #0000001F;\n}\n.togglePasswordButton {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 4px;\n    z-index: 5;\n}\n.errorMessage{\n    color: #ED4337;\n    font-weight: 400;\n    font-style: Regular;\n    font-size: 16px;\n    line-height: 24px;\n}\n.inputError{\n    border-color: #ED4337;\n}\n.errorLabel{\n    color: #ED4337;\n}\n.passwordInputWrapper{\n    position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `AdmissionNoLogin-module__mainContainer`,
	"leftContainer": `AdmissionNoLogin-module__leftContainer`,
	"card": `AdmissionNoLogin-module__card`,
	"rightContainer": `AdmissionNoLogin-module__rightContainer`,
	"loginLogo": `AdmissionNoLogin-module__loginLogo`,
	"loginForm": `AdmissionNoLogin-module__loginForm`,
	"loginFormTitle": `AdmissionNoLogin-module__loginFormTitle`,
	"inputContainer": `AdmissionNoLogin-module__inputContainer`,
	"inputWrapper": `AdmissionNoLogin-module__inputWrapper`,
	"inputLabel": `AdmissionNoLogin-module__inputLabel`,
	"float": `AdmissionNoLogin-module__float`,
	"textInput": `AdmissionNoLogin-module__textInput`,
	"buttonsContainer": `AdmissionNoLogin-module__buttonsContainer`,
	"primaryButton": `AdmissionNoLogin-module__primaryButton`,
	"secondaryButton": `AdmissionNoLogin-module__secondaryButton`,
	"supportMessage": `AdmissionNoLogin-module__supportMessage`,
	"prefilledInput": `AdmissionNoLogin-module__prefilledInput`,
	"changeButton": `AdmissionNoLogin-module__changeButton`,
	"otpInputs": `AdmissionNoLogin-module__otpInputs`,
	"otpInputText": `AdmissionNoLogin-module__otpInputText`,
	"otpInfo": `AdmissionNoLogin-module__otpInfo`,
	"underline": `AdmissionNoLogin-module__underline`,
	"sendOtpButtonContainer": `AdmissionNoLogin-module__sendOtpButtonContainer`,
	"backButtonContainer": `AdmissionNoLogin-module__backButtonContainer`,
	"backButton": `AdmissionNoLogin-module__backButton`,
	"togglePasswordButton": `AdmissionNoLogin-module__togglePasswordButton`,
	"errorMessage": `AdmissionNoLogin-module__errorMessage`,
	"inputError": `AdmissionNoLogin-module__inputError`,
	"errorLabel": `AdmissionNoLogin-module__errorLabel`,
	"passwordInputWrapper": `AdmissionNoLogin-module__passwordInputWrapper`
};
export default ___CSS_LOADER_EXPORT___;
